import {
  COMMON_TRANSLATION_KEYS,
  getFromCommonTranslationKeys,
} from "constants/commonTranslationsKeys";

export const COMMON_TOASTS_IDS = {
  customerNamesFailure: "customer-names-error-toast-id",
  permissionError: "permission-error-toast-id",
  somethingWentWrongError: "something-went-wrong-error-toast-id",
} as const;

export const COMMON_TOASTS = {
  somethingWentWrong: {
    bodyContent: getFromCommonTranslationKeys(
      COMMON_TRANSLATION_KEYS.somethingWentWrong
    ),
    variant: "failure",
    config: {
      toastId: COMMON_TOASTS_IDS.somethingWentWrongError,
    },
  },
  noPermissionError: {
    bodyContent: getFromCommonTranslationKeys(
      COMMON_TRANSLATION_KEYS.youDontHavePermissionToPerformThisAction
    ),
    variant: "failure",
    config: {
      toastId: COMMON_TOASTS_IDS.permissionError,
    },
  },
  customerNamesFailure: {
    bodyContent: getFromCommonTranslationKeys(
      COMMON_TRANSLATION_KEYS.cannotLoadCustomerNames
    ),
    variant: "failure",
    config: {
      toastId: COMMON_TOASTS_IDS.customerNamesFailure,
    },
  },
} as const;
